module.exports = __webpack_public_path__ + "static/media/finished-step-big.73a47c1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/finished-step-big.svg
// module id = 855
// module chunks = 21